/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';
import { useUtilisateurStore } from '@/zustand';

interface UtilisateurZustandProviderProps {
  children: React.ReactNode;
  user: any;
}

const UtilisateurZustandProvider = (props: UtilisateurZustandProviderProps) => {
  const { children, user } = props;

  const setUtilisateur = useUtilisateurStore((state) => state.setUtilisateur);
  const utilisateur = useUtilisateurStore((state) => state.utilisateur);

  React.useEffect(() => {
    if (_.isNil(utilisateur) && process.env.NODE_ENV === 'development') {
      setUtilisateur(user);
    }
  }, [setUtilisateur, user, utilisateur]);

  // Ajoute le header X-Login aux requêtes
  React.useEffect(() => {
    const xLogin = utilisateur?.profil?.identifiant;

    const interceptor = request.interceptors.request.use((config) => {
      config.headers['X-Login'] = xLogin;

      return config;
    });

    return () => {
      request.interceptors.request.eject(interceptor);
    };
  }, [utilisateur?.profil?.identifiant]);

  return children;
};

export default UtilisateurZustandProvider;
